const urlApp = {
  login: '/sso/login',
  singup: '/sso/register',
  verifyToken: '/sso/verify-token',
  getCaptcha: '/captcha',
  getShareCode: '/sso/get-sharing-code',
  logout: '/sso/logout',
  requestOtpPath: '/sso/login/request_otp',
  verifyOtpPath: '/sso/login/verify_otp',
  updateNamePath: '/user/name',
  resetPassword: '/user/reset_password',
  createOrderNoLoginPath: '/customer_order/create_no_login',
  ///
  listProvincePath: '/addresses/provinces',
  listDistrictPath: '/addresses/districts',
  listWardPath: '/addresses/wards',
  listStreetPath: '/addresses/street',
};

export default urlApp;
